import { settings } from '@pixi/settings';

/**
 * Target frames per millisecond.
 *
 * @static
 * @memberof PIXI.settings
 * @type {number}
 * @default 0.06
 */
settings.TARGET_FPMS = 0.06;

export { settings };
